// extracted by mini-css-extract-plugin
module.exports = {"rosteringButtonContainer":"style__rosteringButtonContainer__pJGiJ"};